// Stages 04-06 for Three.js — stubbed behind the seam.
//
// The contract is already fixed by drawlist.js: this backend receives the same
// interleaved Float32Array and hands it to a BufferAttribute rather than
// walking it in a for-loop. Nothing in engine/ changes when this lands, which
// is the whole point of the seam.
//
// z is live as of the depth pass: substrates are stride 3 and the motion stage
// displaces by field value, so the draw list arriving here is genuinely 3D.
// Canvas 2D fakes the camera with a tilt and a clamped divide; this backend
// should read frame.tilt / frame.perspective into a real PerspectiveCamera and
// drop the painter's-algorithm sort in favour of the depth buffer.
//
// Planned mark mapping:
//   dot     -> THREE.Points with a size attribute
//   tick    -> THREE.LineSegments, two vertices per mark from position + angle
//   polygon -> InstancedMesh of a CircleGeometry(sides), instance matrix from
//              position + angle + value; sides is per-layer, not per-mark, so
//              one instanced draw covers the whole layer
//   glyph   -> instanced textured quads from a glyph atlas
//
// Three is intentionally NOT a dependency yet — adding it here would put ~600KB
// into a bundle that currently ships none of it.

export const id = 'three'
export const label = 'Three.js'
export const available = false

export function create() {
  throw new Error(
    'The Three backend is not implemented yet. The draw list contract it will ' +
    'consume is stable (see engine/drawlist.js); only stages 04-06 are missing.',
  )
}
